import React from 'react'
import { OptionsMenu } from '@moonpig/launchpad-components'
import {
  IconSystemCross,
  IconSystemResetFilled,
} from '@moonpig/launchpad-assets'
import {
  createGenericSelectContentEvent,
  trackGAEvent,
} from '@moonpig/web-core-analytics'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import { useStoreId } from '@moonpig/web-core-stores'
import {
  useChatGatewayContext,
  useChatMessagesContext,
  useChatModeContext,
} from '../ChatContext'
import { useLocaleText } from '../locale'
import {
  StyledBasketCountBadge,
  StyledBasketIconLink,
  StyledCloseButton,
  StyledFlex,
  StyledIconSystemBasket,
  StyledHeading,
  StyledMenuAction,
  StyledOptionsMenuWrapper,
} from './styled'

import { useBasketTotalItems } from '@moonpig/web-shared-utils'
import { ConnectionStatus } from '../hooks/types'

export const ChatHeader = () => {
  const { startNewSession, connectionStatus } = useChatGatewayContext()
  const { setInitialMessages } = useChatMessagesContext()
  const { hideChatModal, setIsOptionsMenuOpen } = useChatModeContext()
  const { basketTotalItems } = useBasketTotalItems()
  const t = useLocaleText()
  const coreT = useCoreLocaleText()
  const storeId = useStoreId()
  const basketLabel =
    basketTotalItems > 0
      ? `${coreT('common.basket')} (${basketTotalItems})`
      : coreT('common.basket')

  const isThinking = connectionStatus === ConnectionStatus.Sending

  const startNewChatClickHandler = () => {
    startNewSession()
    setInitialMessages()
  }

  const handleCloseClick = () => {
    trackGAEvent(
      createGenericSelectContentEvent({
        eventCategory: 'ai concierge',
        eventAction: 'close chat',
        eventLabel: 'dismiss icon',
      }),
    )
    hideChatModal()
  }

  return (
    <StyledFlex data-testid={'search-concierge-modal-header'}>
      <StyledOptionsMenuWrapper>
        <OptionsMenu
          label={t('concierge_chat.header_menu_label')}
          onOpenChange={setIsOptionsMenuOpen}
          verticalAlign={'below'}
          horizontalAlign={'right'}
        >
          {[
            <StyledMenuAction
              key="start-new-chat"
              data-testid={'chat-start-new-chat-button'}
              leadingIcon={<IconSystemResetFilled />}
              onClick={startNewChatClickHandler}
              disabled={isThinking}
            >
              {t('concierge_chat.header_menu_option_start_new')}
            </StyledMenuAction>,
          ]}
        </OptionsMenu>
      </StyledOptionsMenuWrapper>
      <StyledHeading level="h2">
        {t('concierge_chat.header_title')}
      </StyledHeading>
      <StyledBasketIconLink to={`/${storeId}/basket/`} aria-label={basketLabel}>
        <StyledIconSystemBasket />
        {basketTotalItems > 0 && (
          <StyledBasketCountBadge>{basketTotalItems}</StyledBasketCountBadge>
        )}
      </StyledBasketIconLink>
      <StyledCloseButton
        data-testid="chat-close-button"
        icon={IconSystemCross}
        label={coreT('common.close')}
        onClick={handleCloseClick}
      />
    </StyledFlex>
  )
}
